import useTranslations from "../../core/i18n/useTranslations";
import Button from "../../ui-lib/components/Button/Button";

import styles from "./MapStub.module.css";

export function MapStub({
  onButtonClick,
}: Readonly<{ onButtonClick: () => void }>) {
  const t = useTranslations();
  return (
    <div className={styles.MapStubContainer}>
      <Button
        variant="secondary"
        text={t("Common:show_map")}
        onClick={onButtonClick}
      />
    </div>
  );
}
